export default 'not_adventurer'
